module.exports = __webpack_public_path__ + "img/appAsset-sources--creditCard.e88d82a5.svg";